<template>
  <div class="hover-menu absolute -left-12 pr-2 top-0 h-full rounded-lg">
    <div class="w-10 py-2 space-y-1.25 bg-white border border-divider-100 rounded flex flex-col items-center text-white">
      <OLink
        class="u-center w-6 h-6 rounded hover:text-white"
        @click="
          openExternalPopup(facebookShareLink);
          $analyticsEvent('User', 'User_Engagement', 'image_share_fb');
        "
      >
        <OIcon icon="article/facebook" svg-class="w-6 h-6" />
      </OLink>
      <OLink
        :style="{ backgroundColor: buttonTwitter.background }"
        class="u-center w-6 h-6 rounded hover:text-white"
        @click="
          openExternalPopup(twitterShareLink);
          $analyticsEvent('User', 'User_Engagement', 'image_share_twitter');
        "
      >
        <OIcon icon="article/twitter-white" svg-class="w-3 h-3 text-white" />
      </OLink>
      <OLink
        class="u-center w-6 h-6 bg-o-yellow rounded hover:bg-red-600 hover:text-white"
        :href="imageLink"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="download-article-image"
        download
        @click="$analyticsEvent('User', 'User_Engagement', 'image_download')"
      >
        <OIcon icon="arrow-right-white" svg-class="w-3 rotate-90" />
      </OLink>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, inject } from '@nuxtjs/composition-api';
import { HOST_URL, TWITTER_USERNAME } from '~/constants/config';
import { getArticleUrl } from '~/modules/common/utils/routingUtils';
import { openExternalPopup } from '~/modules/common/utils/helpers';
import { socialMediaAccounts } from '~/modules/common/components/app/header/headerUtils';
import { getImageUrl } from '~/modules/common/utils/imageUtils';
import { OIcon, OLink } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OIcon, OLink },
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const article = inject('article');
    const articleUrl = computed(() => HOST_URL + getArticleUrl({ article }));
    // facebook share link
    const facebookShareLink = `http://www.facebook.com/sharer/sharer.php?u=${articleUrl.value}?entry=${props.entry?._id}`;
    // twitter share link
    const twitterShareLink =
      `https://twitter.com/intent/tweet?via=${TWITTER_USERNAME}&text=` +
      encodeURIComponent(article.title) +
      '&url=' +
      encodeURIComponent(articleUrl.value) +
      '?entry=' +
      props.entry?._id;
    // download link
    const imageLink = computed(() => getImageUrl(props.entry?.image, { raw: true }));

    const buttonFacebook = socialMediaAccounts.filter((item) => item.name === 'Facebook')[0];
    const buttonTwitter = socialMediaAccounts.filter((item) => item.name === 'Twitter')[0];
    return {
      openExternalPopup,
      facebookShareLink,
      twitterShareLink,
      imageLink,
      buttonFacebook,
      buttonTwitter,
    };
  },
});
</script>

<style lang="scss">
.hover-menu {
  &:before {
    font-family: FontAwesome;
    content: '\25B6';
    display: block;
    position: absolute;
    left: 38px;
    top: 8px;
    font-size: 10px;
    color: #fff;
    text-shadow: 1px 0 0 #d0d0d0;
  }
}
</style>
